export default __webpack_public_path__ + "static/BT_Benefits_Carousel_05-d7e00d04996932b3a44783d6e144cb52.jpg";